import styled from 'styled-components';

export const Description = styled.div`
    width: 100%;
    margin-bottom: 3rem;
    text-align: center;

    h1 {
        font-size: 28px;
        font-weight: 700;
        color: #FFFFFF;
        margin-bottom: 0.5rem;
    }

    p {
        font-size: 16px;
        color: #FFFFFF;
    }

    @media (min-width: 1024px) {
        h1 {
            font-size: 34px;
        }
    }
`;

export const Icon = styled.img`
    margin-bottom: 0.4rem;
`;